import styled from '@emotion/styled'

import { mediaQueryUp } from '~/theme/utils/grid'
import { Heading6 } from '~/theme/utils/typography'

export const MainContainer = styled.footer`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const ItemsContainer = styled.div<{ columns: number }>`
  width: 100%;
  max-width: 21rem;
  gap: 1rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  justify-content: center;
  padding: 2rem 1rem;

  @media (min-width: 760px) {
    max-width: 1080px;
    grid-template-columns: repeat(${({ columns }) => columns || '4'}, 1fr);
    grid-template-rows: 1fr;
    padding: 5rem 3.5rem;
  }
`

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 10rem;

  ${mediaQueryUp('m')} {
    width: 12rem;
  }

  ${mediaQueryUp('l')} {
    max-width: none;
    width: 14rem;
  }
`

export const ItemImageContainer = styled.div`
  display: flex;
  height: 5.5rem;
  width: 5.5rem;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
`

export const ItemImage = styled.img`
  -webkit-user-drag: none;
`

export const ItemContent = styled(Heading6)`
  font-size: 0.875rem;
  text-align: center;
  max-width: 12rem;

  ${mediaQueryUp('m')} {
    font-size: 0.9375rem;
    max-width: none;
  }
`
